import { render, staticRenderFns } from "./StatusAccount.vue?vue&type=template&id=0900885e&"
import script from "./StatusAccount.vue?vue&type=script&lang=js&"
export * from "./StatusAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports